function __decodeHtmlEntities(text) {
  var tempDiv = document.createElement('div');
  tempDiv.innerHTML = text;
  return tempDiv.textContent;
}



function emptyBasket(container) {
    container.style.display = "none";
}

function progressCart(container, subtotal, label, percent, progress) {

    container.style.display = "block";
  
    let rest = Math.round(200 - subtotal) * 100;
    rest = theme.Currency.formatMoney(rest, theme.settings.moneyFormat);
    text = __decodeHtmlEntities(`🎁 Vous n’êtes qu’à ${rest} de la livraison gratuite !`); // TEXTE (ne pas supprimer ${rest})
    label.textContent = text;
  
    let percentage = Math.floor(subtotal / 200 * 100);
    percent.textContent = percentage + "%";
  
    progress.style.width = percentage + "%";
}

function fullCart(container, label, progress) {

    container.style.display = "block";
    
    label.innerHTML = "🎉 Félicitations, la livraison est offerte"; // TEXTE
    progress.style.width = "100%";
}




function cartBooster(subtotalStr) {

  
    let subtotal = parseInt(subtotalStr) / 100;
    const container = document.querySelector('.cart-booster-container');
    const label = container.querySelector('#label');
    const percent = container.querySelector('#percent');
    const progress = container.querySelector('#progress');

    console.log('progressssss');
    console.log(progress);
  
    if (subtotal == 0) {
        emptyBasket(container);
    }
    else if (subtotal < 200) {
        progressCart(container, subtotal, label, percent, progress);
    }
    else {
        fullCart(label, progress);
    }
}